const PREFIX = 'EMPLOYEE_ROLE_';

export const EMPLOYEE_ROLE_PAGE_REQUEST = `${PREFIX}PAGE_REQUEST`;

export const EMPLOYEE_ROLE_ON_CLICK_ROW = `${PREFIX}ON_CLICK_ROW`;

export const EMPLOYEE_ROLES_REQUEST = `${PREFIX}ROLES_REQUEST`;

export const EMPLOYEE_ROLE_DELETE = `${PREFIX}DELETE`;

export const EMPLOYEE_ROLE_SET_ERROR = `${PREFIX}SET_ERROR`;

export const EMPLOYEE_ROLE_ON_CLICK_NEW_ROLE = `${PREFIX}ON_CLICK_NEW_ROLE`;

export const EMPLOYEE_ROLE_OPEN_RIGHT_COLUMN = `${PREFIX}OPEN_RIGHT_COLUMN`;

export const EMPLOYEE_ROLE_CLOSE_RIGHT_COLUMN = `${PREFIX}CLOSE_RIGHT_COLUMN`;

export const EMPLOYEE_ROLE_SET_ROLES = `${PREFIX}SET_ROLES`;

export const EMPLOYEE_ROLE_SET_ROLE_DETAIL = `${PREFIX}SET_ROLE_DETAIL`;

export const EMPLOYEE_ROLE_SET_ASSIGNABLE_PERMISSIONS = `${PREFIX}SET_ASSIGNABLE_PERMISSIONS`;

export const EMPLOYEE_ROLE_SUBMIT_FORM_CREATE = `${PREFIX}SUBMIT_FORM_CREATE`;

export const EMPLOYEE_ROLE_SUBMIT_FORM_UPDATE = `${PREFIX}SUBMIT_FORM_UPDATE`;

export const EMPLOYEE_ROLE_IS_SUBMITTING_FORM = `${PREFIX}IS_SUBMITTING_FORM`;
